import { useEffect } from "react"
import styled from "styled-components"
import gsap from "gsap"

import { useStore } from "@state/store"
import { useProjectDataStore } from "@state/projectDataStore"
import ResidenceInfoCard, { BEDKEY } from "./ResidenceGeneric/ResidenceInfoCard"

function Specification({ selectedUnit }) {
  const contentControls = useStore((s) => s.contentControls)
  const { galleryData } = useProjectDataStore((s) => ({
    galleryData: s.galleryData,
  }))
  const src = galleryData.images[0].content.publicURL
  selectedUnit = selectedUnit?.[0]
  const timeline = gsap.timeline()
  useEffect(() => {
    const active = contentControls?.index === 1
    timeline.to(
      "#specs",
      {
        autoAlpha: active ? 1 : 0,
        duration: 0.4,
        ease: "power3.inOut",
      },
      0.1,
    )
    timeline.to(
      ".spec-anm",
      {
        opacity: 1,
        filter: "blur(0px)",
        duration: 0.6,
        stagger: 0.05,
        ease: "power1.inOut",
      },
      0.3,
    )
    timeline.set(
      ".spec-anm",
      { opacity: 0, filter: "blur(3px)" },
      active ? 0 : ">",
    )
  }, [contentControls])
  return (
    <SpecsWraper id="specs">
      <Data>
        <div className="spec-top spec-anm">
          <div>{BEDKEY[selectedUnit?.beds]}</div>
          <div>|</div>
          <div>
            {selectedUnit?.floor === "0"
              ? "Ground Floor"
              : `Floor ${selectedUnit?.floor}`}
          </div>
        </div>
        <div className="UnitID spec-anm">
          <div>
            <span>Spec</span>ification {selectedUnit?.unitName}
          </div>
        </div>
        <div className="specs">
          <div className="spec-info spec-anm">
            <ul>
              <h2>Kitchen</h2>
              <li>
                Turin range Symphony fitted kitchens in alby blue with brass
                trims and handles – to apartments
              </li>
              <li>
                Turin range Symphony fitted kitchens in alby blue with brass
                trims and handless design – to apartments
              </li>
              <li>
                Pearl granite laminate worktops and co-ordinating upstand with
                splashback behind hob – to one bed apartments
              </li>
              <li>
                White stone work surfaces and co- ordinating upstand with
                splashback behind hob – to all other apartments
              </li>
              <li>
                Charcoal stone work surfaces and co-ordinating upstand with
                splashback behind hob – to houses
              </li>
              <li>
                Inset ash black 1.5 bowl sink with satin bronze mixer tap – to
                one bed apartments
              </li>
              <li>
                Under-mounted ash black 1.5 bowl sink with satin bronze mixer
                tap – to all other homes
              </li>
              <li>Bosch induction 4-ring hob – to apartments</li>
              <li>
                Bosch induction 5-ring hob with stainless steel extractor fan –
                to houses
              </li>
              <li>Bosch stainless steel built-in oven</li>
              <li>
                Bosch stainless steel microwave Bosch freestanding fridge-
                freezer (70/30)
              </li>
              <li>Bosch integrated dishwasher</li>
              <li>
                Bosch free standing washer dryer Integrated bins for recycling
                and waste
              </li>
              <li>LED strip lights underside of wall units</li>
            </ul>
          </div>
          <div className="spec-info spec-anm">
            <ul>
              <h2>Bathroom, shower room and en suite</h2>

              <li>
                Ivory porcelain floor and vanity wall tiles Dark blue accent
                tile – to apartments bathroom
              </li>
              <li>Green accent tile – to houses bathroom</li>

              <li>Green accent tile – to apartments en suite</li>
              <li>Dark blue accent tile – to houses en suite</li>

              <li>Stone vanity top</li>
              <li>
                White sanitaryware with matte black brassware - mixer taps,
                shower head, handset hose, bath filler, shower thermostatic
                valve
              </li>
              <li>Matte black toilet roll holder</li>

              <li>Matte black hooks</li>

              <li>Matte black electric towel rails to en suites</li>

              <li>Shaver socket</li>
            </ul>
            <ul>
              <h2>Interior finishes</h2>
              <li>
                Kandean lime washed oak tiles in chevron design to kitchen,
                living and dining spaces – and store and utility in houses
              </li>
              <li>Opal carpets to bedrooms – and stairs in houses</li>

              <li>Built-in wardrobes to bedroom one</li>

              <li>
                Double glazed windows and doors 2.5m high ceilings in bedrooms,
                living room and kitchen
              </li>
              <li>White sockets and light switches</li>
              <li>LED downlights throughout</li>
            </ul>
          </div>
          <div className="spec-info spec-anm">
            <ul>
              <h2>Heating and cooling</h2>
              <li>Programmable thermostat</li>
              <li>Mechanical underfloor heating</li>
            </ul>
            <ul>
              <h2>Outside</h2>
              <li>Terrace/balcony – to apartments</li>
              <li>Turfed gardens with shed – to houses</li>
              <li>Allocated parking – to houses</li>
              <li>Electric vehicle charge points</li>
            </ul>
            <ul>
              <h2>Security and peace of mind</h2>
              <li>Video door entry system – to apartments</li>
              <li>Lifts – to apartment floors</li>
              <li>Smoke detectors/fire alarms</li>
              <li>Sprinklers installed to all apartments</li>
              <li>999 year lease</li>
              <li>10 year building warranty from completion</li>
            </ul>
            <ul>
              <h2>Security and peace of mind</h2>
              <li>Terrace/balcony – to apartments</li>
              <li>Turfed gardens with shed – to houses</li>
              <li>Allocated parking – to houses</li>
              <li>Electric vehicle charge points</li>
            </ul>
          </div>
        </div>
      </Data>
      <Image src={src} className="spec-anm" />
    </SpecsWraper>
  )
}

export default Specification

const SpecsWraper = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  z-index: 6;
  background-color: white;
`

const Image = styled.img`
  position: absolute;
  z-index: 0;
  right: 0;
  width: 50%;
  height: 100%;
  padding: 1rem;
  object-fit: cover;
  object-position: 80% 50%;
`

const Data = styled.div`
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 2rem;
  padding-left: 5%;
  padding-top: 20rem;
  overflow: scroll;

  .spec-top {
    width: 100%;
    display: flex;
    gap: 1rem;
    font-size: 1.2rem;
    font-family: ThirdFont;
  }
  .UnitID {
    width: 100%;
    display: flex;
    font-size: 5rem;
    font-weight: 400;
    margin: 1rem 0 4rem 0;
    & span {
      font-family: SecondaryFont;
    }
  }
  .specs {
    display: flex;
    flex-direction: row;
  }
  .spec-info {
    padding-left: 0;
    width: calc(100% / 3);
    padding: 2%;
    & ul {
      padding-left: 0;
      list-style: none;

      & h2 {
        font-family: ThirdFont-regular;
        margin: 1rem 0;
      }

      & li {
        opacity: 0.5;
        margin: 8px 0;
        font-family: ThirdFont-regular;
        font-size: 1rem;
      }
    }
  }
`
